import { ChangeEvent } from 'react'
import styled from 'styled-components'
import InputText from '@app.feature/signup/signup/components/inputFields/InputText'
import FormLabel from '@app.feature/signup/signup/desktop/components/FormLabel'

const FieldBirthday = () => {
  const handleBirthdayInput = (e: ChangeEvent<HTMLInputElement>) => {
    const inputText = e.target.value.trim().replace(/[^0-9]/g, '')
    e.target.value = inputText.slice(0, 8)
  }

  return (
    <StyledWrapper>
      <FormLabel label="생년월일" />
      <InputText
        fieldName="birthday"
        placeholder="YYYYMMDD"
        onInputChange={handleBirthdayInput}
        maxLength={8}
      />
    </StyledWrapper>
  )
}
export default FieldBirthday

const StyledWrapper = styled.div`
  display: grid;
  gap: 9px;
`
